import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import BlogDetailsArea from "../components/BlogDetailsArea";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";

const BlogDetails = () => {
  return (
    <>
      <SEO canonical="/blog-details" {...PAGES["/blog-details"]} />
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Blog Details"} />

      {/* Blog Details Area */}
      <BlogDetailsArea />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default BlogDetails;
